import script from "./ExtinguisherVue.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtinguisherVue.vue?vue&type=script&setup=true&lang=js"

import "./ExtinguisherVue.vue?vue&type=style&index=0&id=65b4b932&lang=scss"

const __exports__ = script;

export default __exports__